module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/89a6f14acf501ffda6f1e5c9e7bd8514.png";